import React, { FC } from 'react';
import LanguageSelector from '../LanguageSelector';
import LoginBtn from './LoginBtn';
import s from './LoginArea.module.scss';

export interface NotLoggedinAreaProps {
  value?: string;
  localeDataTranslations?: any;
  keys?: any;
  language: string;
  isInternal?: boolean;
  pageName?: string;
  marketplaceUrlPrefix?: string;
  isLess1000View: boolean;
}

const NotLoggedinArea: FC<NotLoggedinAreaProps> = ({
  keys = {},
  language = 'en',
  pageName = 'explore',
  isLess1000View,
}) => {
  return (
    <>
      <li className={`${s.cell} ${s.desktop} ${s.right}`}>
        <LanguageSelector
          value={language}
          pageName={pageName}
          isLess1000View={isLess1000View}
        />
      </li>
      <li className={`${s.cell} ${s.notLoggedIn} ${s.desktop} ${s.last} `}>
        <LoginBtn btnLoginLabel={keys.btnLogin} pageName={pageName} />
      </li>
    </>
  );
};

export default NotLoggedinArea;
